import "./FooterStyles.css"
import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <div className="top">
                <div><h1>AnyVR</h1>
                    <p>Travel anywhere without any limits</p></div>

                <div>
                    <a href="https://www.facebook.com/profile.php?id=100090543623240"><i className="fa-brands fa-facebook"></i></a>
                    <a href="https://www.instagram.com/dscnitj?igsh=dGhtNHJ2djM2ZXRq"><i className="fa-brands fa-instagram"></i></a>
                    <a href="https://github.com/Sainigurnoor511/AniVR"><i className="fa-brands fa-github"></i></a>
                    <a href="https://twitter.com/googledevs?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"><i className="fa-brands fa-twitter-square"></i></a>
                </div>
            </div>

            <div className="bottom">
                <div>
                    <h4>Project</h4>
                    <a href="/about">Our Mission</a>
                    <a href="/about">Our Vision</a>
                    <a href="/servies">Services</a>
                </div>
                <div>
                    <h4>Community</h4>
                    <a href="https://github.com/login?client_id=de0e3c7e9973e1c4dd77&return_to=%2Flogin%2Foauth%2Fauthorize%3Fclient_id%3Dde0e3c7e9973e1c4dd77%26scope%3Drepo%2Buser%2Bworkflow%26state%3Da04d6c14-03ea-461b-839c-0d99b323a95d>GitHub">GitHub</a>
                    <a href="/contact">Issues</a>
                    <a href="/">Project</a>
                    <a href="https://twitter.com/googledevs?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor">Twitter</a>
                </div>
                <div>
                    <h4>Help</h4>
                    <a href="/contact">Support</a>
                    <a href="/contact">Troubleshooting</a>
                    <a href="/contact">Contact Us</a>
                </div>
                <div>
                    <h4>Others</h4>
                    <a href="/">Terms of Service</a>
                    <a href="/">Privacy Policy</a>
                    <a href="/">License</a>
                </div>
            </div>
        </div>
    )
}

export default Footer
